/*
 * SmartReserve vier batterijen (okt 2026): gedeelde helpers voor de stapelcomponent, matchtest, bespaarcalculator,
 * het blok "In jouw huis" en de vergelijkingspagina.
 *  - SRV.batteries(): de line-up uit window.SR_VIER (metafields + varianten) plus de stapelgegevens (window.SR_STAPEL)
 *  - SRV.store: antwoorden en uitslag lokaal bewaren (localStorage 'sr_vier_v1'), aansluiting ('sr_aansluiting')
 *  - SRV.track(): zelfde route als de bestaande metingen (Shopify customer events 'sr_*', gtag, dataLayer)
 *  - SRV.klaviyo*: client-API, zelfde company en revisie als de bestaande matchtest en calculator
 *  - SRV.maatwerk.open(ctx): knop "Ik wil maatwerkadvies" met WhatsApp of het mailformulier (Klaviyo-event "Maatwerkadvies")
 */
(function (root) {
  'use strict';
  var D = function () { return root.SR_VIER || { products: [], aannames: {} }; };
  var LS_KEY = 'sr_vier_v1', AANSL_KEY = 'sr_aansluiting';

  function ls(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function eur(n) { return '€ ' + Math.round(n).toLocaleString('nl-NL'); }
  function eur2(n) { return '€ ' + (Math.round(n * 100) / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function kwh(n) { return (Math.round(n * 10) / 10).toLocaleString('nl-NL', { maximumFractionDigits: 1 }) + ' kWh'; }
  function watt(n) { return Math.round(n).toLocaleString('nl-NL') + ' W'; }
  function pct(n) { return Math.round(n * 100) + '%'; }

  function batteries() {
    var st = root.SR_STAPEL || {};
    return (D().products || []).slice().sort(function (a, b) { return a.volgorde - b.volgorde; }).map(function (p) {
      var o = {}; for (var k in p) o[k] = p[k];
      o.stapel = st[p.key] || null;
      return o;
    });
  }
  function byKey(key) { return batteries().filter(function (b) { return b.key === key; })[0] || null; }

  var store = {
    get: function () { return ls(LS_KEY); },
    set: function (o) { o.ts = Date.now(); ls(LS_KEY, o); },
    aansluiting: function (v) {
      if (v === undefined) { var a = ls(AANSL_KEY); if (a) return a; var s = ls(LS_KEY); return s && s.raw ? ({ ja: 'groep', nee: 'stopcontact' }[s.raw.groep] || null) : null; }
      ls(AANSL_KEY, v);
      try { document.dispatchEvent(new CustomEvent('srv:aansluiting', { detail: v })); } catch (e) {}
    }
  };

  function track(name, data) {
    data = data || {};
    try { if (root.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('sr_' + name, data); } catch (e) {}
    try { if (typeof root.gtag === 'function') root.gtag('event', 'sr_' + name, data); } catch (e) {}
    try { root.dataLayer = root.dataLayer || []; root.dataLayer.push(Object.assign({ event: 'sr_' + name }, data)); } catch (e) {}
  }
  function ref(prefix) {
    var r; try { r = sessionStorage.getItem('sr_bc_ref'); } catch (e) {}
    if (!r) { r = Math.random().toString(36).slice(2, 6).toUpperCase(); try { sessionStorage.setItem('sr_bc_ref', r); } catch (e) {} }
    return (prefix || 'BC') + '-' + r;
  }
  function utm() { try { return JSON.parse(localStorage.getItem('sr_utm') || '{}'); } catch (e) { return {}; } }
  function intent() { try { return localStorage.getItem('sr_intent') || ''; } catch (e) { return ''; } }

  /* ---------- Klaviyo client-API ---------- */
  function kPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + (D().klaviyo || 'SAAFap'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body)
    }).then(function (r) { if (!(r.ok || r.status === 202)) throw new Error('klaviyo ' + r.status); return r; });
  }
  function klaviyoEvent(metric, email, props, profileProps) {
    return kPost('events', { data: { type: 'event', attributes: {
      properties: props, metric: { data: { type: 'metric', attributes: { name: metric } } },
      profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps || {} } } } } } });
  }
  function klaviyoSubscribe(email, props, source) {
    return kPost('subscriptions', { data: { type: 'subscription', attributes: { custom_source: source || 'Batterijcheck',
      profile: { data: { type: 'profile', attributes: { email: email, properties: props || {} } } } },
      relationships: { list: { data: { type: 'list', id: D().klaviyoList || 'TjFe9x' } } } } });
  }
  function profileProps(beste, prijsklasse, extra) {
    var p = { beste_match: beste ? beste.key : '', beste_match_opstelling: beste ? beste.opstelling : '', prijsklasse: prijsklasse || '' };
    var it = intent(); if (it) p['Thuisbatterij intentie key'] = it;
    for (var k in (extra || {})) p[k] = extra[k];
    return p;
  }

  /* ---------- Antwoorden in gewone woorden ---------- */
  var WOORD = {
    woning: { appartement: 'appartement', rijtjeshuis: 'rijtjeshuis', twee_onder_een_kap: 'twee-onder-een-kap', vrijstaand: 'vrijstaand' },
    groot: { wp: 'warmtepomp', airco: 'airco', ev: 'elektrische auto', inductie: 'inductie', geen: 'geen' },
    contract: { vast: 'vast', variabel: 'variabel', dynamisch: 'dynamisch' },
    wens: { voordelig: 'zo voordelig mogelijk', noodstroom: 'noodstroom', maximaal: 'maximaal besparen', klein: 'klein beginnen' },
    groep: { ja: 'eigen groep (uitgangspunt)', nee: 'gedeelde groep', onbekend: 'eigen groep (uitgangspunt)' }
  };
  function woorden(raw) {
    raw = raw || {};
    return {
      woning: WOORD.woning[raw.woning] || raw.woning || '',
      grote_verbruikers: (raw.groot || []).map(function (g) { return WOORD.groot[g] || g; }).join(', ') || 'geen',
      contract: WOORD.contract[raw.contract] || raw.contract || '',
      wens: WOORD.wens[raw.wens] || raw.wens || '',
      eigen_groep: WOORD.groep[raw.groep] || raw.groep || ''
    };
  }

  /* Uitslag van SRVierModel.compute() naar Klaviyo-objecten */
  function opstellingVan(r) { return r.reqSetup ? r.reqSetup.title + ' (op aanvraag)' : r.setup.title; }
  function urlVan(r) { return 'https://www.smartreserve.nl' + r.bat.url + (r.setup.variantId ? '?variant=' + r.setup.variantId : ''); }
  function besparingVan(r) { return r.ev.yearlyHigh <= 0 ? '€ 0' : 'ongeveer ' + eur(r.ev.yearlyHigh); }
  function uitslagen(res) {
    return res.results.map(function (r) {
      return { klasse: r.bat.klasse, naam: r.bat.klasse, model: r.bat.model, opstelling: opstellingVan(r),
               prijs: r.reqSetup ? 'op aanvraag' : eur(r.price), besparing: besparingVan(r),
               terugverdientijd: root.SRVierModel ? root.SRVierModel.paybackTxt(r.ev) : '', label: r.label, uitleg: r.uitleg, url: urlVan(r) };
    });
  }
  function besteVan(r) {
    return { key: r.key, naam: r.bat.klasse, model: r.bat.model, opstelling: opstellingVan(r), prijs: r.reqSetup ? 'op aanvraag' : eur(r.price), url: urlVan(r) };
  }
  /* Waarop het gunstige scenario rust, in één zin (verdedigbaar als iemand ernaar vraagt) */
  function gunstigTekst() {
    var a = D().aannames || {}, fc = a.feedCostGunstig != null ? a.feedCostGunstig : 0.10;
    return 'Gunstig scenario: je gebruikt het grootste deel van je zonnestroom zelf' + (fc > 0 ? ' en vermijdt terugleverkosten van ' + eur2(fc) + ' per kWh, zoals veel leveranciers die rekenen' : '') + '. Prijzen van 2026, zonder prijsstijging.';
  }
  function prijsklasseVan(price) {
    var a = D().aannames || {};
    return price < (a.grensMidden || 2500) ? 'tot 2500' : (price < (a.grensHoog || 3500) ? '2500 tot 3500' : 'boven 3500');
  }

  /* ---------- Maatwerkadvies ---------- */
  var mw = { el: null, ctx: null };
  function mwBuild() {
    if (mw.el) return mw.el;
    var el = document.createElement('div');
    el.className = 'vb vb-mw'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'vb-mw-title'); el.hidden = true;
    el.innerHTML =
      '<div class="vb-mw__panel">' +
        '<button type="button" class="vb-mw__close" data-mw-close aria-label="Sluiten">×</button>' +
        '<p class="vb-eyebrow" data-mw-eyebrow>Maatwerkadvies</p>' +
        '<h2 class="vb-h3" id="vb-mw-title">We kijken persoonlijk met je mee.</h2>' +
        '<div class="vb-mw__sum" data-mw-sum></div>' +
        '<div data-mw-step="kies"><p class="vb-small" style="margin:0 0 10px">Hoe wil je het bespreken?</p><div class="vb-mw__choices">' +
          '<a class="vb-mw__choice" data-mw-wa target="_blank" rel="noopener" href="#"><span>Via WhatsApp</span><span aria-hidden="true">→</span></a>' +
          '<button type="button" class="vb-mw__choice" data-mw-mail><span>Per mail</span><span aria-hidden="true">→</span></button>' +
        '</div></div>' +
        '<form class="vb-mw__form" data-mw-step="mail" hidden novalidate>' +
          '<label>E-mailadres<input type="email" name="email" required autocomplete="email" inputmode="email"></label>' +
          '<label>Telefoonnummer <span class="vb-small">(optioneel)</span><input type="tel" name="telefoon" autocomplete="tel" inputmode="tel"></label>' +
          '<label>Opmerking <span class="vb-small">(optioneel)</span><textarea name="opmerking" rows="3"></textarea></label>' +
          '<p class="vb-mw__err" data-mw-err hidden>Dat lukte niet. Probeer het zo nog eens, of app ons.</p>' +
          '<button type="submit" class="vb-btn vb-btn--main">Verstuur</button>' +
        '</form>' +
        '<p class="vb-mw__done" data-mw-step="klaar" hidden aria-live="polite"></p>' +
      '</div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) {
      if (e.target === el || (e.target.closest && e.target.closest('[data-mw-close]'))) return mwClose();
      if (e.target.closest && e.target.closest('[data-mw-mail]')) { step('mail'); var f = el.querySelector('input[name=email]'); if (f) f.focus(); return; }
      if (e.target.closest && e.target.closest('[data-mw-wa]')) { mwSent('whatsapp'); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) mwClose(); });
    el.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var f = e.target, email = (f.email.value || '').trim(), err = el.querySelector('[data-mw-err]');
      err.hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { f.email.focus(); f.email.setCustomValidity('Vul een geldig e-mailadres in'); f.email.reportValidity(); setTimeout(function () { f.email.setCustomValidity(''); }, 2000); return; }
      var btn = f.querySelector('button[type=submit]'); btn.disabled = true;
      var c = mw.ctx || {}, b = c.beste || {}, w = c.woorden || {};
      var props = { kanaal: 'mail', bron: c.bron || '', telefoon: (f.telefoon.value || '').trim(), opmerking: (f.opmerking.value || '').trim().slice(0, 1000),
        BatterijcheckRef: c.ref || ref(), beste_match: b.key || '', beste_match_naam: b.naam || '', beste_match_model: b.model || '',
        beste_match_opstelling: b.opstelling || '', beste_match_prijs: b.prijs || '', prijsklasse: c.prijsklasse || '' };
      ['woning', 'grote_verbruikers', 'contract', 'wens', 'eigen_groep'].forEach(function (k) { if (w[k]) props[k] = w[k]; });
      var u = utm(); if (u.utm_source) { props.utm_source = u.utm_source; props.utm_campaign = u.utm_campaign || ''; }
      var pp = profileProps(b, c.prijsklasse, { maatwerkadvies_gevraagd_op: new Date().toISOString().slice(0, 10) });
      klaviyoEvent('Maatwerkadvies', email, props, pp).then(function () {
        btn.disabled = false; mwSent('mail');
        var done = el.querySelector('[data-mw-step="klaar"]'); done.textContent = (D().maatwerk && D().maatwerk.dank) || 'Dank je. We bekijken je situatie en reageren meestal binnen een uur, 7 dagen per week.';
        step('klaar');
      }).catch(function () { btn.disabled = false; err.hidden = false; });
    });
    mw.el = el;
    return el;
  }
  function step(name) { Array.prototype.forEach.call(mw.el.querySelectorAll('[data-mw-step]'), function (s) { s.hidden = s.getAttribute('data-mw-step') !== name; }); }
  function mwSent(kanaal) {
    var c = mw.ctx || {}, b = c.beste || {};
    track('maatwerkadvies', { kanaal: kanaal, beste_match: b.key || '', prijsklasse: c.prijsklasse || '', bron: c.bron || '' });
    if (kanaal === 'whatsapp') {
      // Klaviyo alleen als het profiel al bekend is (onsite klaviyo.js houdt dat bij)
      try {
        var k = root.klaviyo;
        if (k && k.isIdentified) k.isIdentified().then(function (yes) {
          if (!yes) return;
          var w = c.woorden || {};
          var p = { kanaal: 'whatsapp', bron: c.bron || '', BatterijcheckRef: c.ref || '', beste_match: b.key || '', beste_match_naam: b.naam || '', beste_match_model: b.model || '',
                    beste_match_opstelling: b.opstelling || '', beste_match_prijs: b.prijs || '', prijsklasse: c.prijsklasse || '' };
          for (var x in w) if (w[x]) p[x] = w[x];
          k.track('Maatwerkadvies', p);
          k.identify(profileProps(b, c.prijsklasse, { maatwerkadvies_gevraagd_op: new Date().toISOString().slice(0, 10) }));
        });
      } catch (e) {}
    }
  }
  function mwOpen(ctx) {
    var el = mwBuild();
    mw.ctx = ctx = ctx || {};
    if (!ctx.ref) ctx.ref = ref();
    var b = ctx.beste || {};
    var sum = el.querySelector('[data-mw-sum]');
    var lines = [];
    if (b.naam || b.model) lines.push('<strong>' + esc((b.naam ? b.naam + ', ' : '') + (b.model || '')) + '</strong>');
    if (b.opstelling) lines.push(esc(b.opstelling) + (b.prijs ? ' · ' + esc(b.prijs) : ''));
    lines.push('<span class="vb-small">Referentie ' + esc(ctx.ref) + '</span>');
    sum.innerHTML = lines.join('<br>');
    var msg = ctx.waText || ('Hoi SmartReserve! Ik wil graag maatwerkadvies' + (b.model ? ' over de ' + b.model + (b.opstelling ? ' (' + b.opstelling + ')' : '') : '') + '. Referentie ' + ctx.ref + '.');
    el.querySelector('[data-mw-wa]').href = 'https://wa.me/' + (D().wa || '31853036714') + '?text=' + encodeURIComponent(msg);
    el.querySelector('[data-mw-eyebrow]').textContent = ctx.eyebrow || 'Maatwerkadvies';
    el.querySelector('#vb-mw-title').textContent = ctx.title || 'We kijken persoonlijk met je mee.';
    el.querySelector('form').reset();
    step(ctx.step === 'mail' ? 'mail' : 'kies');
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); var c = el.querySelector(ctx.step === 'mail' ? 'input[name=email]' : '[data-mw-wa]'); if (c) c.focus(); });
    mw.lastFocus = document.activeElement;
  }
  function mwClose() {
    if (!mw.el) return;
    mw.el.classList.remove('is-open');
    setTimeout(function () { mw.el.hidden = true; }, 300);
    try { if (mw.lastFocus && mw.lastFocus.focus) mw.lastFocus.focus(); } catch (e) {}
  }

  /* Knoppen met data-srv-maatwerk openen het paneel; de pagina geeft de context via een functie op het element of root.SRV.ctx */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-srv-maatwerk]') : null;
    if (!b) return;
    e.preventDefault();
    var ctx = (b._srvCtx && b._srvCtx()) || (root.SRV.ctxFor && root.SRV.ctxFor(b)) || { bron: b.getAttribute('data-srv-maatwerk') || 'site' };
    mwOpen(ctx);
  });

  /* Rustig verschijnen bij scrollen (alleen als er beweging mag) */
  function reveal() {
    var els = document.querySelectorAll('.vb-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in root) || (root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches)) { Array.prototype.forEach.call(els, function (x) { x.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12 });
    Array.prototype.forEach.call(els, function (x) { io.observe(x); });
  }
  if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', reveal);


  /* ---------- Uitslagkaart (matchtest, calculator, In jouw huis) ----------
     r = één resultaat uit SRVierModel.compute(); opts: { big, cart, groep, minPrice, bron } */
  function standVan(r) {
    var st = r.reqSetup || r.setup, b = r.bat, n = st.units || 1, step = b.stapKwh || st.kwh;
    if (st.parts && st.parts.length > 1) {
      var ms = []; st.parts.forEach(function (p) { for (var i = 0; i < p.qty; i++) ms.push(Math.max(1, Math.round(p.kwh / step))); });
      return { n: ms.length, m: ms };
    }
    var m = st.m || Math.max(1, Math.round(st.kwh / n / step));
    return { n: n, m: m };
  }
  function card(r, opts) {
    opts = opts || {};
    var e = esc, b = r.bat, ev = r.ev, M = root.SRVierModel;
    var st = standVan(r), req = !!r.reqSetup;
    var torens = r.setup.parts && r.setup.parts.length === 1 && r.setup.parts[0].qty > 1 ? '&torens=' + r.setup.parts[0].qty : '';
    var pUrl = b.url + (r.setup.variantId ? '?variant=' + r.setup.variantId + torens : '');
    var h = '<article class="vb-rc' + (opts.big ? ' vb-rc--big' : '') + ' vb-rc--' + r.labelKey + '" data-rc="' + e(r.key) + '">';
    h += '<div class="vb-rc__top"><span class="vb-rc__label">' + e(r.label) + '</span>' +
         '<p class="vb-rc__klasse">' + e(b.klasse) + '</p><h3 class="vb-rc__model">' + e(b.model) + '</h3></div>';
    h += '<div class="vb-rc__stack" data-rc-mini="' + e(r.key) + ',' + st.n + ',' + (Array.isArray(st.m) ? st.m.join('|') : st.m) + '" aria-hidden="true"></div>';
    h += '<p class="vb-rc__setup">' + e(req ? r.reqSetup.title : r.setup.title) + '<span>' +
         (req ? 'Prijs op aanvraag' : eur(r.price)) + '</span></p>';
    h += '<p class="vb-rc__why">' + e(r.uitleg) + '</p>';
    var bes = ev.yearlyHigh <= 0 ? '€ 0' : 'ongeveer ' + eur(ev.yearlyHigh);
    var rows = [
      ['Wat hij bij jou doet', 'Bewaart ' + pct(ev.surplusPct) + ' van je zonoverschot en dekt ' + pct(ev.nightPct) + ' van je avond- en nachtverbruik'],
      ['Besparing per jaar', bes],
      ['Terugverdientijd', M ? M.paybackTxt(ev) : ''],
      ['Winst over 10 jaar', ev.net10High > 0 ? 'ongeveer ' + eur(ev.net10High) : 'nog niet terugverdiend binnen 10 jaar']
    ];
    if (opts.perKwh && !req && r.price > 0 && r.setup && r.setup.kwh > 0) {
      rows.splice(1, 0, ['Prijs per kWh opslag', e(eur(r.price / r.setup.kwh))]);
    }
    if (r.extraGroep && r.extraGroep.yearlyHigh > 0) {
      rows.push(['Op een eigen, vrije groep', 'tot ' + watt(r.extraGroep.w) + ' en ongeveer ' + eur(Math.max(0, r.extraGroep.yearlyHigh)) + ' per jaar extra']);
    }
    var dl = '<dl class="vb-rc__dl">' + rows.map(function (x) { return '<div><dt>' + x[0] + '</dt><dd>' + (x[0].indexOf('per kWh') !== -1 ? x[1] : e(x[1])) + '</dd></div>'; }).join('') + '</dl>' +
             '<p class="vb-small vb-rc__basis">' + e(gunstigTekst()) + '</p>';
    if (opts.big) h += dl; else h += '<details class="vb-rc__more"><summary>Toon de doorrekening</summary>' + dl + '</details>';
    if (b.extra && b.extra.length && opts.minPrice && r.price > opts.minPrice) {
      h += '<div class="vb-rc__extra"><p>Wat je extra krijgt</p><ul class="vb-list">' + b.extra.map(function (x) { return '<li>' + e(x) + '</li>'; }).join('') + '</ul></div>';
    }
    h += '<div class="vb-actions vb-rc__btns">';
    if (opts.cart && !req) h += '<a class="vb-btn vb-btn--main" href="' + e(M ? M.cartPath(r.setup) : pUrl) + '" data-rc-cart>In winkelmand</a>';
    h += '<a class="vb-btn ' + (opts.cart && !req ? 'vb-btn--line' : 'vb-btn--line') + '" href="' + e(pUrl) + '">Bekijk deze opstelling</a>';
    if (req || opts.maatwerk) h += '<button type="button" class="vb-btn ' + (req && !opts.cart ? 'vb-btn--line' : 'vb-btn--ink') + '" data-srv-maatwerk="' + e(opts.bron || 'site') + '" data-rc-mw="' + e(r.key) + '">Ik wil maatwerkadvies</button>';
    h += '</div>';
    if (opts.note) h += '<p class="vb-mw-note vb-rc__note">' + e(opts.note) + '</p>';
    return h + '</article>';
  }
  function mountMinis(box) {
    if (!root.SRStapel) return;
    Array.prototype.forEach.call(box.querySelectorAll('[data-rc-mini]'), function (el) {
      var a = el.getAttribute('data-rc-mini').split(','), m = a[2].indexOf('|') !== -1 ? a[2].split('|').map(Number) : +a[2];
      root.SRStapel.mini(el, a[0], +a[1], m);
    });
  }
  root.SRV = {
    batteries: batteries, byKey: byKey, store: store, track: track, ref: ref, utm: utm, intent: intent, esc: esc,
    eur: eur, eur2: eur2, kwh: kwh, watt: watt, pct: pct,
    klaviyoEvent: klaviyoEvent, klaviyoSubscribe: klaviyoSubscribe, profileProps: profileProps,
    woorden: woorden, uitslagen: uitslagen, besteVan: besteVan, besparingVan: besparingVan, opstellingVan: opstellingVan, urlVan: urlVan,
    prijsklasseVan: prijsklasseVan, maatwerk: { open: mwOpen, close: mwClose }, card: card, mountMinis: mountMinis, standVan: standVan
  };
})(window);
